import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Container,
  Box,
  Breadcrumbs,
  Link,
  Alert
} from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navigation from './Navigation';
import { useMediaQuery } from '@mui/material';
import Logo from '../assets/logo.png';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

function Layout({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');
  const isOnline = useNetworkStatus();

  // Get current page title from path
  const getPageTitle = (pathname) => {
    const routes = {
      '/dashboard': 'Dashboard',
      '/transactions': 'Transactions',
      '/reports': 'Reports',
      '/users': 'User Management',
      '/settings': 'Settings'
    };
    return routes[pathname] || 'Artha Bhaskar';
  };

  // Breadcrumb navigation
  const pathnames = location.pathname.split('/').filter((x) => x);
  
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* Desktop Sidebar */}
      <Sidebar />
      
      {/* Main Content Area */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        {/* Header */}
        <AppBar 
          position="static" 
          style={{ 
            backgroundColor: '#1976d2',
            boxShadow: 'none'
          }}
        >
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {getPageTitle(location.pathname)}
            </Typography>
            <Typography variant="body2">
              {user ? `Logged in as: ${user.email}` : 'Not logged in'}
            </Typography>
          </Toolbar>
        </AppBar>
        
        {/* Breadcrumb Navigation */}
        <Container maxWidth="lg" style={{ padding: '10px 20px 0 20px' }}>
          <Breadcrumbs 
            separator={<NavigateNextIcon fontSize="small" />} 
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate('/dashboard')}
              style={{ cursor: 'pointer' }}
            >
              Dashboard
            </Link>
            {pathnames.map((value, index) => {
              const last = index === pathnames.length - 1;
              const to = `/${pathnames.slice(0, index + 1).join('/')}`;

              return last ? (
                <Typography color="text.primary" key={to}>
                  {getPageTitle(to)}
                </Typography>
              ) : (
                <Link
                  underline="hover"
                  color="inherit"
                  onClick={() => navigate(to)}
                  style={{ cursor: 'pointer' }}
                  key={to}
                >
                  {getPageTitle(to)}
                </Link>
              );
            })}
          </Breadcrumbs>
        </Container>

        {/* Offline Alert */}
        {!isOnline && (
          <Alert severity="warning" style={{ margin: '10px 20px' }}>
            You are currently offline. Some features may not work.
          </Alert>
        )}

        {/* Page Content */}
        <Container 
          maxWidth="lg" 
          style={{ 
            padding: '20px', 
            marginTop: '10px',
            marginBottom: isMobile ? '70px' : '20px' // Space for mobile nav
          }}
        >
          {children}
        </Container>
      </Box>
      
      {/* Mobile Bottom Navigation */}
      <Navigation />
    </Box>
  );
}

export default Layout;